import { isAndOrOperator } from "./isAndOrOperator";
import { EditorFilter } from "../types";

// // // //

/**
 * sortEditorFilter
 * Sorts the nested filters of an EditorFilter recursively based on specific criteria.
 * @function sortEditorFilter
 * @param {EditorFilter} filter - The EditorFilter to sort the nested filters of.
 * @returns {EditorFilter} - The modified EditorFilter with the nested filters sorted.
 */
export function sortEditorFilter(filter: EditorFilter): EditorFilter {
    filter.nested.sort((a, b) => {
        if (
            !isAndOrOperator(a.state.operator) &&
            isAndOrOperator(b.state.operator)
        ) {
            return -1; // a should come before b
        } else if (
            isAndOrOperator(a.state.operator) &&
            !isAndOrOperator(b.state.operator)
        ) {
            return 1; // a should come after b
        } else {
            return 0; // no sorting needed for these two items
        }
    });

    filter.nested.forEach((nestedFilter) => {
        sortEditorFilter(nestedFilter); // Recursively sort the nested filters
    });

    return filter;
}

/**
 * sortEditorFilterArray
 * Sorts an array of EditorFilters
 * @function sortEditorFilterArray
 * @param {EditorFilter[]} filters  - The EditorFilter array to sort
 * @returns {EditorFilter} - The sorted EditorFilter array
 */
export function sortEditorFilterArray(filters: EditorFilter[]): EditorFilter[] {
    filters.sort((a, b) => {
        if (
            !isAndOrOperator(a.state.operator) &&
            isAndOrOperator(b.state.operator)
        ) {
            return -1; // a should come before b
        } else if (
            isAndOrOperator(a.state.operator) &&
            !isAndOrOperator(b.state.operator)
        ) {
            return 1; // a should come after b
        } else {
            return 0; // no sorting needed for these two items
        }
    });

    return filters;
}
